import { Flex, Text } from "@chakra-ui/react";

export default function Registros(props: any) {
  return (
    <Flex w={"100%"} flexDirection={"column"} mt={4}>
      <Text fontSize={"14px"} fontWeight={"700"} color={"#1C3E92"}>
        {props.title}
      </Text>
      <Text fontSize={"14px"}>{props.value}</Text>
    </Flex>
  );
}
